import { Helmet } from "react-helmet";

import { SharedWithMe } from "../components/SharedWithMe/SharedWithMe";

export default function SharedWithMePage() {
  return (
    <>
      <Helmet>
        <title>Shapr3D - Dashboard</title>
        <meta
          name="description"
          content="Review designs together. View models and add comments directly to your 3D design."
        />
      </Helmet>
      <SharedWithMe />
    </>
  );
}
